import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'outline' | 'danger' | 'gradient';
  fullWidth?: boolean;
  className?: string;
  disabled?: boolean;
}
export function Button({
  children,
  onClick,
  variant = 'primary',
  fullWidth = false,
  className = '',
  disabled = false
}: ButtonProps) {
  const baseStyles = 'px-6 py-3 rounded-lg font-bold text-base transition-all active:scale-98 disabled:opacity-50 disabled:cursor-not-allowed';
  const variantStyles = {
    primary: 'bg-[#3dc7e3] text-white hover:bg-[#2db5d1] shadow-md',
    secondary: 'bg-white text-[#1f5070] border-2 border-[#3dc7e3] hover:bg-gray-50',
    outline: 'bg-transparent text-[#1f5070] border border-gray-300 hover:bg-gray-50',
    danger: 'bg-[#E53935] text-white hover:bg-[#D32F2F] shadow-md',
    gradient: 'bg-gradient-to-r from-[#3dc7e3] to-[#c7f61e] text-white hover:opacity-90 shadow-md'
  };
  const widthStyles = fullWidth ? 'w-full' : '';
  return <button onClick={onClick} disabled={disabled} className={`${baseStyles} ${variantStyles[variant]} ${widthStyles} ${className}`} style={{
    height: '48px'
  }} data-id="element-69">
      {children}
    </button>;
}